import { render, staticRenderFns } from "./LeaderboardQuestionCard.vue?vue&type=template&id=ffb8edea&"
import script from "./LeaderboardQuestionCard.vue?vue&type=script&lang=js&"
export * from "./LeaderboardQuestionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports